import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { BarcodeScanner } from '@ionic-native/barcode-scanner';

//PROVIDERS
import { Services, Tools } from '../../providers';

//PAGES
import { ListaGestorPage } from '../listaGestor/listaGestor';

@IonicPage()
@Component({
  selector: 'page-pedido',
  templateUrl: 'pedidoGestor.html',
})
export class PedidoGestorPage {
  pedido:any;
  code:string='';

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private barcodeScanner: BarcodeScanner,
    private services: Services,
    private tools: Tools
  ) {
    this.pedido = this.navParams.get('item');
  }

  openScanner(){
    this.barcodeScanner.scan().then(barcodeData => {
      if(barcodeData.text==''){return}
      barcodeData.text = barcodeData.text.toUpperCase();
      if(this.pedido.entrega.caixas.indexOf(barcodeData.text)>=0){this.tools.showAlert('toast','Caixa existente.');return}
      this.pedido.entrega.caixas.push(barcodeData.text);
    }).catch(err => {
        console.log('Error', err);
    });
  }

  removeCaixa(i){
    this.pedido.entrega.caixas.splice((i*1),1);
  }

  addCaixa(){
    this.code = this.code.toUpperCase();

    if(this.code == ''){this.tools.showAlert('toast','Preencha o campo para adicionar manualmente.');return;}
    if(this.pedido.entrega.caixas.indexOf(this.code)>=0){this.tools.showAlert('toast','Caixa existente.');return}

    this.pedido.entrega.caixas.push(this.code);
    this.code = '';
  }

  liberarPedido(){
    if(this.pedido.entrega.caixas.length == 0){
      alert('Adicione no mínimo uma caixa.');return;
    }

    if(this.code != ''){
      var x = confirm('Há uma caixa parcialmente preenchida, deseja descartá-la?');
      if(!x){return}
    }

    var x =  confirm('Deseja realmente liberar este pedido?');
    if(!x){return}

    this.pedido.entrega.status = 'Liberado';
    this.services.save('cadPedidos',this.pedido,(result)=>{
      this.navCtrl.setRoot(ListaGestorPage);
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/pedidoGestor/pedidoGestor.ts